"use strict";

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.createFallbackPrepare = createFallbackPrepare;
var _pick2 = _interopRequireDefault(require("lodash/pick"));
var _JSONStringifyHuman = _interopRequireDefault(require("./JSONStringifyHuman"));
function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
var OPTIONS = {
  maxEntries: 2,
  maxDepth: 2,
  maxBreadth: 2,
  ignoreKeys: ['_id', '_type', '_key', '_ref']
};
function createFallbackPrepare(fieldNames) {
  return value => ({
    title: (0, _JSONStringifyHuman.default)((0, _pick2.default)(value, fieldNames), OPTIONS)
  });
}